import Collection from 'umg-ember-backend/components/record-explorer/for/collection';

<template><Collection @records={{@model}} @recordType='collection' /></template>
